"use client";

import { useCallback, useEffect, useMemo, useState } from "react";

export function useOnScreen<T extends Element>() {
  const [isIntersecting, setIntersecting] = useState(true);

  const observer = useMemo<IntersectionObserver | null>(() => {
    if (typeof window === "undefined") {
      return null;
    }

    return new IntersectionObserver(([entry]) =>
      setIntersecting(entry.isIntersecting),
    );
  }, []);

  const ref = useCallback(
    (node: T | null) => {
      if (!node) return;

      observer?.observe(node);
    },
    [observer],
  );

  useEffect(() => {
    return () => {
      observer?.disconnect();
    };
  }, [observer]);

  return [ref, isIntersecting] as const;
}
